import type { CustomFile } from '../types';

import getRootFolderNames from './getRootFolderNames';
import groupFilesByRootFolder, { type TypeGroupedFilesResult } from './groupFilesByRootFolder';

// ----------------------------------------------------------------------------

export type TypeStatsFiles = {
    groupedFiles: TypeGroupedFilesResult;
    isDrag: boolean;
    rootFolders: string[];
    totalSize: number;
};

// ----------------------------------------------------------------------------

function statsFiles(files: CustomFile[], isDrag: boolean): TypeStatsFiles {
    const data: TypeStatsFiles = {
        groupedFiles: {},
        isDrag: false,
        rootFolders: [],
        totalSize: 0,
    };

    // Foreach Files
    for (const file of files) {
        // Total Size
        data.totalSize += file.size;
    }

    //
    if (isDrag) {
        data.isDrag = true;
        data.rootFolders = getRootFolderNames(files);
        data.groupedFiles = groupFilesByRootFolder(files);
    }

    //
    return data;
}

// ----------------------------------------------------------------------------

export default statsFiles;
